import * as websocket from "../util/websocket.js";
import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";

export {init,destroy}
Html.registerWidget('widget/map-notificationhandler',{init:init,destroy:destroy})

var askingLocationModal;


Html.register({
  "requestlocation":ApiServer.locrequestpositionrefresh.prepare(async function(hasSent){
    modal.closeModal()
    if(websocket.isActive){
      askingLocationModal = await modal.alertModal('map.locationRefreshSentWithNotif');
    }else{
      askingLocationModal = await modal.alertModal('map.locationRefreshSent');
    }
  }),
  "requestautotrack":ApiServer.locrequestautotrack.prepare(async function(hasSent){
    modal.closeModal()
    askingLocationModal = await modal.alertModal('map.locationRequestAutotrackSent');
  })
});



function refresh(webPushMessage){
  modal.closeModal(askingLocationModal);
  
  var watchingUserId= $("[data-fw-location-accountid]").attr("data-fw-location-accountid");
  if(watchingUserId===webPushMessage.push.targetId){
    amplify.publish('familyMemberSelected',{selected:watchingUserId});
  }else{
    $("[data-fw-onclick='maprefresh']").trigger('click');
  }
}
/*
 * for debugging use
 * emulateNotification({type:"push",push:{messageType:"GeolocPositionRefreshResponse",targetId:29766}})
 * 
 */
function init(obj){
  websocket.subscribe(["GeolocAutotrackAccepted","GeolocPositionRefreshResponse","New_Checkin"],refresh);
}
function destroy(obj){
  websocket.unsubscribe(["GeolocAutotrackAccepted","GeolocPositionRefreshResponse","New_Checkin"],refresh);
}